import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const PaymentCancelPage = () => {
  const navigate = useNavigate();
  const basePath = process.env.REACT_APP_BASE_URL || "";

  return (
    <Container className="mt-5 text-center">
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        size="3x"
        className="text-warning mb-3"
      />
      <h1 className="text-warning mb-3">Payment Cancelled</h1>
      <Alert variant="warning">
        <p>Your payment has been cancelled. Your card was not charged.</p>
        <p className="mb-0">Feel free to try again whenever you're ready.</p>
      </Alert>

      <div className="mt-4">
        <button
          className="btn btn-primary me-2"
          onClick={() => navigate(`${basePath}/one-time-payment`)}
        >
          Browse Products
        </button>
        <button
          className="btn btn-secondary"
          onClick={() => navigate(`${basePath}/dashboard`)}
        >
          Back to Dashboard
        </button>
      </div>
    </Container>
  );
};

export default PaymentCancelPage;
